export const initialSmarchAnimationBasic = { opacity: 0}
export const initialSmarchAnimation = { opacity: 0, x: '100%', scale: 0.5 }
export const initialSmarchAnimationY = { opacity: 0, y: '10%', scale: 0.7 }
export const SmarchAnimateBasic =  { opacity: 1  }
export const SmarchAnimate =  { opacity: 1, x: '0', scale: 1, y: '0' }
export const SmarchAnimateY =  { opacity: 1, scale: 1, y: '0' }
export const SmarchTransition = { duration: 0.38 }
export const exitAnimation = { opacity: 0}